import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import FileUploader from 'Components/Files/Uploader';
import { FILE_UPLOAD_TYPES } from 'Consts/Queries';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  iconButtonText: {
    fontSize: theme.typography.h6.fontSize,
    color: theme.palette.facet.primaryBlue,
  },
}));

const EmailAttachmentForm = ({
  agenda,
  householdId,
  onAttachmentChange,
  onStartFileUpload,
  onFinishFileUpload,
  setUploadProgress,
  className,
}) => {
  const classes = useStyles();
  return (
    <FileUploader
      params={{
        type: FILE_UPLOAD_TYPES.emailAttachment,
        meetingAgendaId: agenda?.id(),
        householdId,
      }}
      onStart={onStartFileUpload}
      onFinally={onFinishFileUpload}
      onCatch={err => displayErrorMessage(err, 'Could not attach document')}
      onSuccess={onAttachmentChange}
      successToastMessage="Attachment Uploaded Successfully"
      setUploadProgress={setUploadProgress}
    >
      <Button className={className}>
        <AttachFileIcon />
        <Typography className={classes.iconButtonText}>Attach File</Typography>
      </Button>
    </FileUploader>
  );
};

EmailAttachmentForm.defaultProps = {
  className: null,
};

EmailAttachmentForm.propTypes = {
  className: PropTypes.string,
  agenda: PropTypes.object.isRequired,
  householdId: PropTypes.string.isRequired,
  onAttachmentChange: PropTypes.func.isRequired,
  onStartFileUpload: PropTypes.func.isRequired,
  onFinishFileUpload: PropTypes.func.isRequired,
  setUploadProgress: PropTypes.func.isRequired,
};

export default EmailAttachmentForm;
